import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';

export const onCopyButtonClick = async (issueKey: string): Promise<void> => {
	try {
		await performGetRequest(`/rest/api/2/issue/${issueKey}`);
	} catch (error: unknown) {
		fireErrorAnalytics({
			error: error instanceof Error ? error : new Error('Unknown error'),
			meta: {
				id: 'getIssueSimilarWorkItemsInGIC',
				packageName: '@atlassian/jira-issue-create',
				teamName: 'GRAVITY',
			},
			sendToPrivacyUnsafeSplunk: true,
		});
	}
};
